import { render, staticRenderFns } from "./ship_notice.vue?vue&type=template&id=36b43a89&scoped=true"
import script from "./ship_notice.vue?vue&type=script&lang=js"
export * from "./ship_notice.vue?vue&type=script&lang=js"
import style0 from "./ship_notice.vue?vue&type=style&index=0&id=36b43a89&prod&scoped=true&lang=less"
import style1 from "./ship_notice.vue?vue&type=style&index=1&id=36b43a89&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b43a89",
  null
  
)

export default component.exports